import React from 'react';
import Api from "../../servicios/api";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch, faTimes, faArrowRight, faAngleDoubleLeft, faAngleLeft, faAngleDoubleRight, faAngleRight, faSave } from '@fortawesome/free-solid-svg-icons'
import Swal from 'sweetalert2';

class Medicamentos extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            datosCargados: false,
            pagina: [],
            usuarios: [],
            seleccionados: [] // Array para almacenar los medicamentos seleccionados
        }
    }

    // Manejar selección/deselección de medicamentos
    toggleSeleccion = (medicamento) => {
        this.setState(prevState => {
            const existeIndex = prevState.seleccionados.findIndex(item => item.codigo_int === medicamento.codigo_int);
            
            if (existeIndex !== -1) {
                // Si ya existe, lo removemos
                const nuevosSeleccionados = [...prevState.seleccionados];
                nuevosSeleccionados.splice(existeIndex, 1);
                return { seleccionados: nuevosSeleccionados };
            } else {
                // Si no existe, lo agregamos con cantidad por defecto 1
                return { 
                    seleccionados: [
                        ...prevState.seleccionados, 
                        { 
                            ...medicamento, 
                            cantidad: 1 
                        }
                    ] 
                };
            }
        });
    }

    // Actualizar cantidad de un medicamento seleccionado
    actualizarCantidad = (codigo_int, cantidad) => {
        this.setState(prevState => ({
            seleccionados: prevState.seleccionados.map(item =>
                item.codigo_int === codigo_int ? { ...item, cantidad: parseInt(cantidad) || 1 } : item
            )
        }));
    }

    // Verificar si un medicamento está seleccionado
    estaSeleccionado = (codigo_int) => {
        return this.state.seleccionados.some(item => item.codigo_int === codigo_int);
    }

    // Registrar todos los medicamentos seleccionados
    registrarSeleccionados = () => {
        const { seleccionados } = this.state;
        
        if (seleccionados.length === 0) {
            Swal.fire('Advertencia!', 'No hay medicamentos seleccionados', 'warning');
            return;
        }

        const orden = document.getElementById('ordenint').value;
        const fac = document.getElementById('relacionadomed').value || '0';
        const gastar_m = 'Si';
        const inv = 1;

        // Validar cantidades
        for (const medicamento of seleccionados) {
            if (inv === 0 && medicamento.cantidad > medicamento.cant_disponible) {
                Swal.fire('Error!', `La cantidad de ${medicamento.nombre_medicamento} es mayor al stock disponible`, 'error');
                return;
            }
        }

        // Preparar datos para enviar
        const datosEnvio = seleccionados.map(medicamento => ({
            orden,
            cod: medicamento.codigo_int,
            stock: medicamento.cant_disponible,
            cant: medicamento.cantidad,
            inv,
            fac,
            gastar_m
        }));

        Swal.fire({
            title: '¿Registrar medicamentos?',
            text: `Se registrarán ${seleccionados.length} medicamento(s)`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sí, registrar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                this.enviarMedicamentos(datosEnvio);
            }
        });
    }

    // Enviar medicamentos al servidor
    enviarMedicamentos = (datosEnvio) => {
        Swal.showLoading();
        
        fetch(Api + "Insumos/SaveMedicamentosAsigMultiple", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ medicamentos: datosEnvio })
        })
        .then(respuesta => respuesta.json())
        .then((datosRespuesta) => {
            Swal.fire('Éxito!', datosRespuesta.msj, 'success');
            
            // Limpiar selección
            this.setState({ seleccionados: [] });
            
            // Recargar datos si existe la función
            if (this.props && this.props.Cargar && typeof this.props.Cargar === 'function') {
                this.props.Cargar();
            }
        })
        .catch(error => {
            console.error('Error:', error);
            Swal.fire('Error!', 'Ocurrió un error al registrar los medicamentos', 'error');
        });
    }

    resetFormadd() {
        document.getElementById('buscarmediadd').value = "";
        document.getElementById('bnombremedadd').value = "";
        document.getElementById('bnombremedadd').focus();
        this.BuscarMedicamentoadd(1);
    }

    componentDidMount() {
        this.BuscarMedicamentoadd(1);
    }

    BuscarMedicamentoadd(page){
        let codmed = document.getElementById('buscarmediadd').value;
        let bname = document.getElementById('bnombremedadd').value;
        
        if(codmed === '') codmed = 0;
        if(bname === '') bname = 0;
        
        fetch(Api + "SearchMedicamentos/"+codmed+"/"+bname+"?page="+page)
          .then((respuesta) => respuesta.json())
          .then((datosRespuesta) => {
            this.setState({ 
                datosCargados: true, 
                usuarios: datosRespuesta.data, 
                pagina: datosRespuesta.total, 
                ultimo: datosRespuesta.last_page, 
                actual: datosRespuesta.current_page 
            });
          })
          .catch(console.log);
    }

    render() {
        const { datosCargados, usuarios, pagina, ultimo, actual, seleccionados } = this.state;
        
        if (!datosCargados) {
            var load = 'Cargando datos....';
        } else {
            var load = '';
        }

        return (
            <div className="modal-dialog modal-lg modal-dialog-scrollable">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="nuevaEnfermedad1Label">Medicamentos</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="card">
                            <div style={{ backgroundImage: 'linear-gradient(#2FB3FB, #003153)', color: '#FFFFFF', borderTopLeftRadius: 5, borderTopRightRadius: 5 }} className="card-header text-center">
                                <h5 style={{ fontSize: 18 }} >Lista de Medicamentos</h5>
                            </div>
                            <div className='card-body'>
                                {/* Barra de herramientas */}
                                <div className="row mb-3">
                                    <div className="col-xl-5">
                                        <input type="text" id="buscarmediadd" name="buscarmedi" placeholder="Codigo Medicamento" className="form-control form-control-sm" />
                                    </div>
                                    <div className="col-xl-3">
                                        <input type="text" id="bnombremedadd" name="bnombremed" placeholder="Descripcion del medicamento" className="form-control form-control-sm" />
                                    </div>
                                    <div className="col-xl-4">
                                        <button type="button" className="btn btn-primary btn-sm" onClick={() => this.BuscarMedicamentoadd(1)}>
                                            <FontAwesomeIcon icon={faSearch} />&nbsp;&nbsp;Buscar
                                        </button>&nbsp;&nbsp;
                                        <button type="button" className="btn btn-danger btn-sm" onClick={() => this.resetFormadd()} >
                                            <FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar
                                        </button>
                                    </div>
                                </div>

                                {/* Contador de seleccionados */}
                                {seleccionados.length > 0 && (
                                    <div className="alert alert-info py-2">
                                        <div className="row align-items-center">
                                            <div className="col">
                                                <strong>{seleccionados.length}</strong> medicamento(s) seleccionado(s)
                                            </div>
                                            <div className="col text-end">
                                                <button 
                                                    type="button" 
                                                    className="btn btn-success btn-sm"
                                                    onClick={this.registrarSeleccionados}
                                                >
                                                    <FontAwesomeIcon icon={faSave} />&nbsp;&nbsp;
                                                    Registrar Seleccionados
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Tabla de medicamentos */}
                                <div className="row">
                                    <table className="table table-hover table-condensed table-sm">
                                        <thead className="thead-inverse">
                                            <tr>
                                                <th>SELECCIÓN</th>
                                                <th>ITEM</th>
                                                <th>CODIGO</th>
                                                <th>DESCRIPCION</th>
                                                <th>STOCK</th>
                                                <th>CANTIDAD</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {load}
                                            {usuarios.map((itemUsuarios) => {
                                                const estaSeleccionado = this.estaSeleccionado(itemUsuarios.codigo_int);
                                                const medicamentoSeleccionado = estaSeleccionado 
                                                    ? this.state.seleccionados.find(item => item.codigo_int === itemUsuarios.codigo_int)
                                                    : null;
                                                
                                                return (
                                                    <tr key={itemUsuarios.id} className={estaSeleccionado ? 'table-primary' : ''}>
                                                        <td>
                                                            <input
                                                                type="checkbox"
                                                                checked={estaSeleccionado}
                                                                onChange={() => this.toggleSeleccion(itemUsuarios)}
                                                                className="form-check-input"
                                                            />
                                                        </td>
                                                        <td>{itemUsuarios.id}</td>
                                                        <td>{itemUsuarios.codigo_int}</td>
                                                        <td>{itemUsuarios.nombre_medicamento}</td>
                                                        <td>{itemUsuarios.cant_disponible}</td>
                                                        <td>
                                                            {estaSeleccionado ? (
                                                                <input 
                                                                    type="number" 
                                                                    value={medicamentoSeleccionado?.cantidad || 1}
                                                                    onChange={(e) => this.actualizarCantidad(itemUsuarios.codigo_int, e.target.value)}
                                                                    className="form-control form-control-sm" 
                                                                    style={{width: "80px"}}
                                                                    min="1"
                                                                    max={itemUsuarios.cant_disponible}
                                                                />
                                                            ) : (
                                                                <span className="text-muted">-</span>
                                                            )}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>

                                {/* Paginación */}
                                <div className="row">
                                    <div className='col-xs-12'>
                                        <nav aria-label="Page navigation example">
                                            <ul className="pagination">
                                                <li className="page-item">
                                                    <a className="page-link" href="#" onClick={() => this.BuscarMedicamentoadd(1)}>
                                                        <FontAwesomeIcon icon={faAngleDoubleLeft} />
                                                    </a>
                                                </li>
                                                <li className="page-item">
                                                    <a className="page-link" href="#" onClick={() => this.BuscarMedicamentoadd(actual - 1)}>
                                                        <FontAwesomeIcon icon={faAngleLeft} />
                                                    </a>
                                                </li>
                                                <li className="page-item">
                                                    <a className="page-link" href="#" onClick={() => this.BuscarMedicamentoadd(actual)}>
                                                        {actual}
                                                    </a>
                                                </li>
                                                <li className="page-item">
                                                    <a className="page-link" href="#" onClick={() => this.BuscarMedicamentoadd(actual + 1)}>
                                                        <FontAwesomeIcon icon={faAngleRight} />
                                                    </a>
                                                </li>
                                                <li className="page-item">
                                                    <a className="page-link" href="#" onClick={() => this.BuscarMedicamentoadd(ultimo)}>
                                                        <FontAwesomeIcon icon={faAngleDoubleRight} />
                                                    </a>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                    <div className="card-footer text-muted">
                                        <b>Pagina</b> <span className="badge bg-primary">{actual}</span> <b>de</b> <span className="badge bg-primary">{ultimo}</span> | <b>Registros</b> <span className="badge bg-success">{pagina}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Medicamentos;